import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['field', 'nestedFields', 'removeBtn']
  static classes = ['hidden']
  static values = { index: Number }

  initialize() {
    this.initIndexValue()
    this.toggleRemoveBtns()
    this.removeIsValidClass()
  }

  add() {
    this.indexValue++
    this.addNewField()
    this.toggleRemoveBtns()
  }

  remove(event) {
    const field = event.currentTarget.closest('.js--nested-field')

    if (event.currentTarget.dataset.should_alert == 'true') {
      this.displayAlert(event)
      this.handleFieldRemoval(field)
    } else {
      this.handleFieldRemoval(field)
    }
  }

  displayAlert(event) {
    window.alert(event.currentTarget.dataset.alert_message)
  }

  // private

  handleFieldRemoval(field) {
    this.removeField(field)
    this.toggleRemoveBtns()
  }

  initIndexValue() {
    const lastField = this.fieldTargets[this.fieldTargets.length - 1]
    this.indexValue = lastField.dataset.index
  }

  removeIsValidClass() {
    // Simple Form builder adds 'is-valid' class to nested fields on init (no clue why)
    this.fieldTargets.forEach(field => {
      field.querySelector('input').classList.remove('is-valid')
    })
  }

  removeField(field) {
    field.remove()
    this.removeAssociatedHiddenFields(field)
  }

  addNewField() {
    const newFieldSet = this.cleanedDupField(this.fieldTarget)
    this.nestedFieldsTarget.insertAdjacentHTML('beforeend', newFieldSet)
  }

  toggleRemoveBtns() {
    this.removeBtnTargets.forEach(item => {
      item.hidden = false
    })

    if (this.removeBtnTargets.length == 1) {
      this.removeBtnTarget.hidden = true
    }
  }

  cleanedDupField(fieldToDuplicate) {
    const targetedIndex = fieldToDuplicate.dataset.index
    const indexRegex = new RegExp(targetedIndex, 'g')

    return fieldToDuplicate.outerHTML
      .replace(indexRegex, this.indexValue)
      .replace('is-invalid', '')
      .replace('is-valid', '')
      .replace(/value="[^"]+"/, "value=''")
  }

  removeAssociatedHiddenFields(field) {
    const targetedIndex = field.dataset.index

    this.nestedFieldsTarget
      .querySelectorAll(`input[name^='report_division[report_division_entities_attributes][${targetedIndex}]']`)
      .forEach(input => {
        input.remove()
      })
  }
}
